import fetch from '@ixigo/fetch';
import type { ApiErrorResponse } from '@/api';
import { executeApiCall } from '@/api/helper';

export type CancellationReason = {
	label: string;
	id: number;
};

export type CancellationCharges = {
	amount: number;
	currency: string;
	applicable: boolean;
	metaInfo: {
		title: string;
		subtitle: string;
		imageUrl: string;
	};
};

export interface CancellationSuccessResponse {
	data: {
		reasons: Array<CancellationReason>;
		cancellationCharges: CancellationCharges;
	};
}

export type CancellationErrorType =
	| 'INVALID_BOOKING_ID'
	| 'API_ERROR'
	| 'GENERIC_ERROR';

export type CancellationErrorResponse = ApiErrorResponse<CancellationErrorType>;
export type CancellationResponse =
	| CancellationSuccessResponse
	| CancellationErrorResponse;
export const getCancellationDetail = async (
	bookingId: string,
): Promise<CancellationResponse> => {
	return executeApiCall(
		() =>
			fetch
				.get<CancellationResponse>(
					`cabs/api/v1/cancellationDetails/${bookingId}`,
					{
						headers: {
							'Content-Type': 'application/json',
						},
					},
				)
				.json(),
		`getCancellationDetail:${bookingId}`,
	);
};

export type InitiateCancellationSuccessResponse = {
	data: {
		success: boolean;
		message: string;
	};
};

export type InitiateCancellationErrorResponse =
	ApiErrorResponse<InitiateCancellationErrorType>;
export type InitiateCancellationResponse =
	| InitiateCancellationSuccessResponse
	| InitiateCancellationErrorResponse;

export type InitiateCancellationErrorType = 'API_ERROR' | 'GENERIC_ERROR';

export const initiateCancellation = async (
	bookingId: string,
	cancellationReason: CancellationReason,
	options?: { signal?: AbortSignal },
): Promise<InitiateCancellationResponse> => {
	return executeApiCall(
		() =>
			fetch
				.post<InitiateCancellationResponse>('cabs/api/v1/cancelBooking', {
					body: JSON.stringify({
						bookingId,
						cancellationReason: cancellationReason.label,
						cancellationReasonId: cancellationReason.id,
					}),
					headers: {
						'Content-Type': 'application/json',
					},
					signal: options?.signal,
				})
				.json(),
		`initiateCancellation:${bookingId}`,
	);
};
